import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './StoryBox.module.scss';

import { Container } from 'common/components/Layout/Layout';
import ContentBox from './ContentBox/ContentBox';

class StoryBox extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    const { date, title, subtitle, text } = this.props.data;
    return (
      <Container>
        <div className={styles.Circle} />
        <Container className={styles.StoryBox}>
          <div className={styles.YearContainer}>
            <div className={styles.LeftArrow} />
            <p className={styles.Year}>{this._extractYearFromDate(date)}</p>
          </div>
          <ContentBox title={title} subtitle={subtitle} text={text} />
        </Container>
      </Container>
    );
  }

  _extractYearFromDate(date) {
    return date ? new Date(date).getFullYear() : '';
  }
}

export default StoryBox;



// WEBPACK FOOTER //
// ./src/views/History/components/StoryBox/StoryBox.js